import styled from "styled-components";
import Styles from "@themes/Styles";
import { BrowserUtil } from "@util/index";

const APPS = [
    {
        image: "https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2Fapps%2Femoji-promo-image.png?alt=media&token=67d448ab-e0f3-4d64-a874-e6b5833860c1",
        appUrl: "https://www.emojify.art",
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2Fapps%2Fflip-clock-promo-image.png?alt=media&token=8992de5e-f79d-40bf-9d0d-5646f4160ca3",
        appUrl: "https://lifeat.io/tools/clock",
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2Fapps%2Ftimer-promo-image.png?alt=media&token=ab7085dc-7ed9-4681-aae6-62e6f3fdefa2",
        appUrl: "https://lifeat.io/tools/timer",
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2Fapps%2Fpomodoro-promo-image.png?alt=media&token=49565883-e068-46f4-837d-a40126de620e",
        appUrl: "https://lifeat.io/tools/pomodoro",
    },
];

const HEADER_LABEL = "Featured apps:";

const Container = styled.div<{ show: boolean }>`
    display: ${({ show }) => (show ? "block" : "none")};
    overflow: auto;
    align-items: center;
    height: 100%;
    border-radius: ${Styles.widgetBorderRadius};
    background-color: ${({ theme }) => theme.backgroundPrimary};
    padding: 20px;

    & .lifeat-volume-slider {
        padding: 0;
        & input {
            margin-left: 0;
        }
    }

    & .volume-slider-toggle {
        padding-left: 0;
        & .volume-icon {
            transform: none;
        }
    }
`;

const SidebarHeader = styled.h1`
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 24px;
`;

const AppInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    cursor: pointer;
`;

const AppImage = styled.img`
    width: 100%;
`;

const AppList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

type AppsWidgetProps = {
    show: boolean;
};
export function AppsSidebar(props: AppsWidgetProps) {
    return (
        <Container show={props.show}>
            <SidebarHeader>{HEADER_LABEL}</SidebarHeader>
            <AppList>
                {APPS.map((app, index) => (
                    <AppInfoContainer key={app.appUrl} onClick={() => BrowserUtil.openLinkNewTab(app.appUrl)}>
                        <AppImage src={app.image} />
                    </AppInfoContainer>
                ))}
            </AppList>
        </Container>
    );
}
